import { Language, LanguageCode, TypeCall } from '@/types/common';
import { InterpretationLanguage } from '@/types/components';
import { ResponseInterpretationLanguage } from '@/types/response';

export const LANGUAGE_MAP: Record<LanguageCode, Language> = {
  ko: { code: 'ko', name: '한국어', nameInKorean: '한국어', smallName: 'KO', type: ['asia'] },
  en_US: { code: 'en_US', name: 'English', nameInKorean: '영어', smallName: 'EN', type: ['america', 'asia', 'europe'] },
  ja: { code: 'ja', name: '日本語', nameInKorean: '일본어', smallName: 'JA', type: ['asia'] },
  zh: { code: 'zh', name: '中文 (简体)', nameInKorean: '중국어(간체)', smallName: 'ZH', type: ['asia'] },
  es: { code: 'es', name: 'Español', nameInKorean: '스페인어', smallName: 'ES', type: ['europe', 'america'] },
  de: { code: 'de', name: 'Deutsch', nameInKorean: '독일어', smallName: 'DE', type: ['europe'] },
  ru: { code: 'ru', name: 'Русский', nameInKorean: '러시아어', smallName: 'RU', type: ['europe', 'asia'] },
  fr: {
    code: 'fr',
    name: 'Français',
    nameInKorean: '프랑스어',
    smallName: 'FR',
    type: ['europe', 'africa', 'america'],
  },
  it: { code: 'it', name: 'Italiano', nameInKorean: '이탈리아어', smallName: 'IT', type: ['europe'] },
  hi: { code: 'hi', name: 'हिंदी', nameInKorean: '힌디어', smallName: 'HI', type: ['asia'] },
  vi: { code: 'vi', name: 'Tiếng Việt', nameInKorean: '베트남어', smallName: 'VI', type: ['asia'] },
  id: { code: 'id', name: 'Bahasa Indonesia', nameInKorean: '인도네시아어', smallName: 'ID', type: ['asia'] },
  th: { code: 'th', name: 'ภาษาไทย', nameInKorean: '태국어', smallName: 'TH', type: ['asia'] },
  pt: {
    code: 'pt',
    name: 'Português',
    nameInKorean: '포르투갈어',
    smallName: 'PT',
    type: ['europe', 'america', 'africa'],
  },
  tr: { code: 'tr', name: 'Türkçe', nameInKorean: '터키어', smallName: 'TR', type: ['europe', 'asia'] },
  pl: { code: 'pl', name: 'Polski', nameInKorean: '폴란드어', smallName: 'PL', type: ['europe'] },
  ar: { code: 'ar', name: 'العربية', nameInKorean: '아랍어', smallName: 'AR', type: ['asia', 'africa'] },
  ms: { code: 'ms', name: 'Bahasa Melayu', nameInKorean: '말레이어', smallName: 'MS', type: ['asia'] },
  nl: { code: 'nl', name: 'Nederlands', nameInKorean: '네덜란드어', smallName: 'NL', type: ['europe'] },
  zh_TW: { code: 'zh_TW', name: '中文 (繁體)', nameInKorean: '중국어(번체)', smallName: 'ZH-TW', type: ['asia'] },
  mn: { code: 'mn', name: 'Монгол хэл', nameInKorean: '몽골어', smallName: 'MN', type: ['asia'] },
  sv: { code: 'sv', name: 'Svenska', nameInKorean: '스웨덴어', smallName: 'SV', type: ['europe'] },
  fi: { code: 'fi', name: 'Suomalainen', nameInKorean: '핀란드어', smallName: 'FI', type: ['europe'] },
  fa: { code: 'fa', name: 'فارسی', nameInKorean: '페르시아어', smallName: 'FA', type: ['europe'] },
};

export const INPUT_LANGAUGE: TypeCall[] = ['GENERAL', 'CONFERENCE']; // 음성 입력 언어

export const INITIAL_INTERPRETATION_LANGUAGES: InterpretationLanguage = {
  inputEnabled: [],
  textOutputEnabled: [],
  voiceOutputEnabled: [],
};

// TODO: 임시 api/chat/business/call/language/option 로 요청 받은 값을 받을 예정
export const DUMMY_INTERPRETATION_LANGUAGES: ResponseInterpretationLanguage = {
  inputEnabled: [
    'ko',
    'en_US',
    'ja',
    'zh',
    'es',
    'de',
    'ru',
    'fr',
    'it',
    'hi',
    'vi',
    'id',
    'th',
    'pt',
    'tr',
    'pl',
    'ar',
    'ms',
    'nl',
    'zh_TW',
  ],
  textOutputEnabled: [
    'ko',
    'en_US',
    'ja',
    'zh',
    'es',
    'de',
    'ru',
    'fr',
    'it',
    'hi',
    'vi',
    'id',
    'th',
    'pt',
    'tr',
    'pl',
    'ar',
    'ms',
    'nl',
    'zh_TW',
    'mn',
  ],
  voiceOutputEnabled: [
    'ko',
    'en_US',
    'ja',
    'zh',
    'es',
    'de',
    'ru',
    'fr',
    'it',
    'hi',
    'vi',
    'id',
    'th',
    'pt',
    'tr',
    'pl',
    'ar',
    'ms',
    'nl',
    'zh_TW',
  ],
};

export const RTL_LANGUAGES = ['ar'];
